import { supabase } from './supbaseClient';

let _token: string | null = null;
let _expiresAt: number | null = null;

export const getToken = async () => {
  // Maps from milliseconds to seconds
  const now = Math.floor(Date.now() / 1000);
  // If there is no token, no expiration info, or the expiration date is behind us
  if (!_token || !_expiresAt || _expiresAt <= now) {
    const {
      data: { session }
    } = await supabase.auth.getSession();
    _token = session?.access_token || null;
    _expiresAt = session?.expires_at || null;
  }

  if (!_token) {
    throw new Error('Unable to get token. Unauthorized.');
  }
  return _token;
};

supabase.auth.getSession().then(({ data: { session } }) => {
  _token = session?.access_token || null;
});

supabase.auth.onAuthStateChange((_event, session) => {
  _token = session?.access_token || null;
});
